 <template>
    <div v-if="withlabel">
        <div :class="formClass">
            <label class="control-label col-md-3">{{ title }}</label>
            <div class="col-md-9">
                <date-picker
                    :id="id"
                    :value="value"
                    input-class="form-control"
                    :config="config"
                    :disabled="disabled"
                    @input="updateValue($event)"
                ></date-picker>
                <span v-if="errorText" class="help-block">
                    <p v-html="errorText"></p>
                </span>
            </div>
        </div>
    </div>
    <div v-else>
        <date-picker
            :id="id"
            :value="value"
            input-class="form-control"
            :config="config"
            :disabled="disabled"
            @input="updateValue($event)"
        ></date-picker>
        <span v-if="errorText" class="help-block">
            <p v-html="errorText"></p>
        </span>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'moment/locale/pl'
import datePicker from 'vue-bootstrap-datetimepicker'
import mixins from '@js/mixins'

// Import date picker css
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
  components: {
    datePicker
  },
  mixins: [mixins],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Date, Object],
      default: null,
    },
    rawError: {
      type: Boolean,
      default: false
    },
    time : {
      type: Boolean,
      default : true
    },
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: null
    },
    errors: {
      type: Object,
      default: function () {
        return {}
      }
    },
    withlabel: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      id : `form_${this.name}`,
      config: {
        format: this.time ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD',
        locale: 'pl',
      },
    }
  },
  computed: {
    errorText(value) {
      if (value && this.name) {
        const error = this.getNestedObjectValue(value, this.name)

        if (error && this.rawError) {
          return error
        } else if (error) {
          return Object.values(error).join('<br>')
        }
      }

      return ''
    },
    hasError: function () {
      return this.errorText !== ''
    },
    formClass: function () {
      return this.hasError ? 'form-group has-error' : 'form-group'
    }
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event ? event.format(this.config.format) : null)
    },
  },
}
</script>
